import styled from 'styled-components';

export const InterfaceContainer = styled.div`
  padding: 1rem;
`;
